import { render, staticRenderFns } from "./CoreUI.vue?vue&type=template&id=2f0aa2be"
import script from "./CoreUI.vue?vue&type=script&lang=js"
export * from "./CoreUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports